import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { DateTime, SystemZone } from 'luxon'
import CUDatePicker from '@/components/CUDatePicker.vue'
import CUTimePickerList from '@/components/CUTimePickerList.vue'
import { PropType } from 'vue/types/v3-component-props'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotItineraryStopDatetime',
  props: {
  index: {
    type: Number as PropType<number>,
    required: true,
  },
  datetime: {
    type: Object as PropType<DateTime | null>,
    required: false, // optional since null is allowed
  },
  zoneId: {
    type: String as PropType<string | null>,
    required: false,
  },
  minimumDatetime: {
    type: Object as PropType<DateTime>,
    required: true,
  },
},
  emits: ['datetime:update'],
  setup(__props, { emit }) {

const props = __props;

const DEFAULT_STOP_TIME = '08:00:00'





const date = computed(() => props.datetime ? props.datetime.toFormat('yyyy-LL-dd') : '')
const time = computed(() => props.datetime ? props.datetime.toFormat('HH:mm:ss.SSS') : '')

const minimumDate = computed(() => props.minimumDatetime?.toISODate())

const formattedStopDate = computed(() =>
  props.datetime ? props.datetime.toFormat('LL/dd/yyyy') : ''
)

const formattedStopTime = computed(() =>
  props.datetime ? props.datetime.toFormat('hh:mm a') : ''
)

const minTime = computed(() => {
  if (!minimumDate.value || date.value > minimumDate.value) {
    return undefined
  }
  return props.minimumDatetime.toFormat('HH:mm:ss.SSS')
})

const zone = computed(() => props.zoneId || new SystemZone().name)

/**
 * Update the date value
 * @param {string} event - The new date value as ISO Date string
 */
const onDateUpdate = (value: string): void => {
  const isoTime = time.value || getDefaultStopTime(value)
  const newDatetime = buildDateTime(value, isoTime)
  emit('datetime:update', newDatetime)
}

const onTimeUpdate = (value: string): void => {
  const newDatetime = buildDateTime(date.value || getDefaultStopDate(), value)
  emit('datetime:update', newDatetime)
}

const buildDateTime = (dateISO: string, timeISO: string): DateTime | null => {
  if (!dateISO || !timeISO) return null
  const iso = `${dateISO}T${timeISO}`
  const datetime = DateTime.fromISO(iso, { zone: zone.value })
  return datetime
}

const getDefaultStopTime = (date: string): string => {
  if (!props.minimumDatetime) {
    return DEFAULT_STOP_TIME
  }

  const zonedDate = DateTime.fromISO(date, { zone: zone.value })
  if (zonedDate > props.minimumDatetime && props.index === 0) {
    return DEFAULT_STOP_TIME
  }

  const defaultDatetime = props.minimumDatetime
    .plus({ hours: 1 })
    .startOf('hour')

  return defaultDatetime.toFormat('HH:mm:ss.SSS')
}

const getDefaultStopDate = (): string => {
  const timeOnMinimumDate = buildDateTime(minimumDate.value, DEFAULT_STOP_TIME)
  if (timeOnMinimumDate < props.minimumDatetime) {
    // get the next day
    return props.minimumDatetime.plus({ days: 1 }).toISODate()
  }
  return minimumDate.value
}


return { __sfc: true,DEFAULT_STOP_TIME, props, emit, date, time, minimumDate, formattedStopDate, formattedStopTime, minTime, zone, onDateUpdate, onTimeUpdate, buildDateTime, getDefaultStopTime, getDefaultStopDate, CUDatePicker, CUTimePickerList }
}

})